import React, { useState } from 'react'
import itsme1 from "../assets/gallery/1.jpeg";
import itsme2 from "../assets/gallery/2.jpeg";
import itsme3 from "../assets/gallery/3.jpeg";
import itsme4 from "../assets/gallery/4.jpeg";
import itsme5 from "../assets/gallery/5.jpeg";
import itsme6 from "../assets/gallery/6.jpeg";
import itsme7 from "../assets/gallery/7.jpeg";
import itsme8 from "../assets/gallery/8.jpeg";
import itsme9 from "../assets/gallery/9.jpeg";
import itsme10 from "../assets/gallery/10.jpeg";
import itsme11 from "../assets/gallery/11.jpeg";
import itsme12 from "../assets/gallery/12.png";
import itsme13 from "../assets/gallery/13.jpg";
import itsme14 from "../assets/gallery/14.JPG";
import Loading from "./Loading";

function GalleryImage({ src, alt = "", width, height }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className="relative w-full overflow-hidden rounded-lg"
      style={{ aspectRatio: `${width} / ${height}` }}
    >
      {!loaded && (
        <Loading className="absolute inset-0" sizeClass="h-14 w-14" />
      )}
      <img
        className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-300 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        src={src}
        alt={alt}
        width={width}
        height={height}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export default function Gallery() {
  return (
    <section className="py-14">
    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
      <div className="max-w-xl md:mx-auto">
        <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
        Gallery of Accomplishments
        </h3>
        <p className="mt-3 text-gray-600">
        A Showcase of Noteworthy Accomplishments and Unforgettable Events in My Journey
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="grid gap-4">
          <div>
            <GalleryImage src={itsme1} width={1186} height={890} />
          </div>
          <div>
            <GalleryImage src={itsme9} width={1280} height={2276} />
          </div>
          <div>
            <GalleryImage src={itsme3} width={2048} height={944} />
          </div>
        </div>
        <div className="grid gap-4">
          <div>
            <GalleryImage src={itsme4} width={2048} height={1536} />
          </div>
          <div>
            <GalleryImage src={itsme5} width={2048} height={1226} />
          </div>
          <div>
            <GalleryImage src={itsme6} width={1080} height={1080} />
          </div>
          <div>
            <GalleryImage src={itsme13} width={1101} height={561} />
          </div>          
        </div>
        <div className="grid gap-4">
          <div>
            <GalleryImage src={itsme11} width={800} height={499} />
          </div>
          <div>
            <GalleryImage src={itsme8} width={800} height={533} />
          </div>
          <div>
            <GalleryImage src={itsme2} width={927} height={695} />
          </div>
          <div>
            <GalleryImage src={itsme14} width={6720} height={4480} />
          </div>
        </div>
        <div className="grid gap-4">
          <div>
            <GalleryImage src={itsme10} width={1280} height={2276} />
          </div>
          <div>
            <GalleryImage src={itsme7} width={2048} height={1152} />
          </div>
          <div>
            <GalleryImage src={itsme12} width={585} height={322} />
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}
